// extracted by mini-css-extract-plugin
export default {"title":"NewCaseForm4_title__eacq7","content":"NewCaseForm4_content__3TNOB"};